import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './assets/css/normallize.css';
import animated from 'animate.css'  
import VueAwesomeSwiper from 'vue-awesome-swiper'
import axios from 'axios'
import VueAxios from 'vue-axios'
// or import all icons if you don't care about bundle size
import 'vue-awesome/icons'
/* Register component with one of 2 methods */
import Icon from 'vue-awesome/components/Icon'
import 'swiper/dist/css/swiper.css'

// globally (in your main .js file)
Vue.component('v-icon', Icon)
Vue.use(VueAxios, axios)
Vue.use(animated)
Vue.use(VueAwesomeSwiper, /* { default options with global component } */)

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
